import { useRef, useState } from "react";

import { GroupByFilterEntities } from "../types";

// EVA-6412 SR-002 — homeless shared local state (fixes P4, P5). See the
// DEVIATION note on GroupByFilterEntities in types.ts for why bin/legend state
// live in useBinSettingsController/useLegendController instead of here.
export const useGroupByFilterEntities = (): GroupByFilterEntities => {
  const [defaultFiltersLoaded, setDefaultFiltersLoaded] = useState(false);
  const [readyForDefaultFilter, setReadyForDefaultFilter] = useState(false);

  const [isActiveFilterVisible, setIsActiveFilterVisible] = useState(true);
  const [isLegendVisible, setIsLegendVisible] = useState(true);
  const [isBatchOperationsOpen, setIsBatchOperationsOpen] = useState(false);
  const [groupModePopoverOpen, setGroupModePopoverOpen] = useState(false);
  const [showGroupBy, setShowGroupBy] = useState(false);
  const [showTreeMap, setShowTreeMap] = useState(false);

  // Keyed by property so switching fields and back correctly detects a date range
  // change (P5 exception — genuinely transient, not a Redux mirror).
  const lastSeenDateRangeByPropertyRef = useRef<Record<string, string>>({});

  return {
    defaultFiltersLoaded,
    setDefaultFiltersLoaded,
    readyForDefaultFilter,
    setReadyForDefaultFilter,
    isActiveFilterVisible,
    setIsActiveFilterVisible,
    isLegendVisible,
    setIsLegendVisible,
    isBatchOperationsOpen,
    setIsBatchOperationsOpen,
    groupModePopoverOpen,
    setGroupModePopoverOpen,
    showGroupBy,
    setShowGroupBy,
    showTreeMap,
    setShowTreeMap,
    lastSeenDateRangeByPropertyRef
  };
};
